import { render, staticRenderFns } from "./ZbVideoList.vue?vue&type=template&id=3642d59c"
import script from "./ZbVideoList.vue?vue&type=script&lang=js"
export * from "./ZbVideoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports